import dynamic from "next/dynamic";

export const DynamicContent051 = dynamic(() => import("./Content051"), {
  suspense: true,
});
